import { Circle, Polygon, Rectangle, Tooltip } from "react-leaflet";
import L from "leaflet";

// Saved region -> shape Leaflet can draw (null if the data is unusable)
const regionToShape = (region) => {
  const pts = (region?.points || []).filter(
    (p) => Number.isFinite(p?.lat) && Number.isFinite(p?.long)
  );
  const latlngs = pts.map((p) => [p.lat, p.long]);

  if (region?.type === "Circle" && latlngs.length >= 2) {
    return {
      kind: "circle",
      center: latlngs[0],
      radius: L.latLng(latlngs[0]).distanceTo(L.latLng(latlngs[1])),
    };
  }
  // Polygon and Rectangle (saved as 4 corners) are both polygons
  if (latlngs.length >= 3) return { kind: "polygon", positions: latlngs };
  return null;
};

const RegionLayers = ({ regions, selectedId, color, fillColor, interactive }) => (
  <>
    {regions.map((region) => {
      const shape = regionToShape(region);
      if (!shape) return null;

      const selected = region._id === selectedId;
      const active = region.active !== false;

      const pathOptions = {
        color: selected ? "#FFD700" : active ? color : "#9e9e9e",
        fillColor: active ? fillColor : "#9e9e9e",
        fillOpacity: active ? 0.35 : 0.15,
        weight: selected ? 3 : 2,
        dashArray: active ? undefined : "6 6",
      };

      const label = <Tooltip sticky>{region.name}</Tooltip>;

      return shape.kind === "circle" ? (
        <Circle
          key={`${region._id}-${selected}-${active}`}
          center={shape.center}
          radius={shape.radius}
          pathOptions={pathOptions}
          interactive={interactive}
        >
          {label}
        </Circle>
      ) : (
        <Polygon
          key={`${region._id}-${selected}-${active}`}
          positions={shape.positions}
          pathOptions={pathOptions}
          interactive={interactive}
        >
          {label}
        </Polygon>
      );
    })}
  </>
);

export { RegionLayers, regionToShape };